<template>
  <div class="search-container">
    <span class="icon-text" v-if="!keyword">
      <img src="@/assets/img/search.png" alt="放大镜" />
      <span>搜索</span>
    </span>
    <input type="text" v-model="keyword" :class="{ expanded: keyword }" />
  </div>
</template>

<script>
export default {
  name: "SearchPage",
  data() {
    return {
      keyword: "",
    };
  },
};
</script>

<style lang="less" scoped>
.search-container {
  position: absolute !important;
  z-index: 20 !important;
  top: 54px;
  right: 46px;
  width: auto; /* 由 input 控制宽度 */
  font-size: 22px;
  color: #0852af;
}

.search-container input {
  width: 180px;
  padding: 12px 16px 12px 20px;
  border-radius: 30px;
  outline: none;
  border: none;
  background: linear-gradient(
    180deg,
    rgba(129, 185, 255, 0.85) 0%,
    rgba(204, 227, 255, 1) 100%
  );
  box-sizing: border-box;
  transition: width 0.3s ease; /* 平滑动画 */
}

/* 输入时变长 */
.search-container input.expanded {
  width: 280px;
}

/* 左侧图标+文字 */
.search-container .icon-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  pointer-events: none;
}

.search-container .icon-text img {
  width: 24px;
  margin-right: 10px;
}
</style>
